module.exports = __webpack_public_path__ + "img/medicine-management_4.228bc167.png";